import React from 'react';
import { Col, Form, Row, Typography, Checkbox } from 'antd';
import { useTranslation } from 'react-i18next';

const CommunicationsCheckboxesSection = ({ isView, isStaffOnly }) => {
  const { t } = useTranslation();

  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>
          {t('CANALI DI COMUNICAZIONE')}
        </Typography.Title>
      </Col>
      <Col span={18}>
        <Row gutter={8}>
          <Col>
            <Form.Item label='' name='is_archive' valuePropName={'checked'}>
              <Checkbox disabled={isView || isStaffOnly}>
                Uso Archivio (printers)
              </Checkbox>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label='' name='is_newsletter' valuePropName={'checked'}>
              <Checkbox disabled={isView || isStaffOnly}>
                NEWSLETTER (newsletter)
              </Checkbox>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label='' name='is_radio' valuePropName={'checked'}>
              <Checkbox disabled={isView || isStaffOnly}>
                RADIO VILLAGE (radio)
              </Checkbox>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label='' name='is_social' valuePropName={'checked'}>
              <Checkbox disabled={isView || isStaffOnly}>
                SOCIAL (social)
              </Checkbox>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label='' name='is_web' valuePropName={'checked'}>
              <Checkbox disabled={isView || isStaffOnly}>WEB</Checkbox>
            </Form.Item>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default React.memo(CommunicationsCheckboxesSection);
